"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }/* Reads the {{name}} and {{name | fallback}} tokens of a broadcast template,
 * with the same parsing rules as renderTemplate (shared/services/broadcastTemplate),
 * so the composer can highlight tokens and tell which variables have a fallback. */


var _broadcastTemplate = require('shared/services/broadcastTemplate');

const TOKEN_PATTERN = /\{\{([^{}]*)\}\}/g
const NAME_PATTERN = /^[A-Za-z0-9_]+$/
const EDGE_SPACE = /^[ \t\n\r\f\v]+|[ \t\n\r\f\v]+$/g

const trimSpace = (value) => value.replace(EDGE_SPACE, '')













 const templateTokens = (template) => {
  const tokens = []
  for (const match of template.matchAll(TOKEN_PATTERN)) {
    const inner = _nullishCoalesce(match[1], () => ( ''))
    const pipe = inner.indexOf('|')
    const name = trimSpace(pipe < 0 ? inner : inner.slice(0, pipe))
    tokens.push({
      name,
      fallback: pipe < 0 ? null : trimSpace(inner.slice(pipe + 1)),
      index: _nullishCoalesce(match.index, () => ( 0)),
      text: match[0],
      isValidName: NAME_PATTERN.test(name),
    })
  }
  return tokens
}; exports.templateTokens = templateTokens

/* A variable's fallback in this template: the first fallback given for it,
 * or null when every use of it lacks one. */
 const fallbackFor = (tokens, name) => {
  for (const token of tokens) {
    if (token.name === name && token.fallback !== null) return token.fallback
  }
  return null
}; exports.fallbackFor = fallbackFor

/* True when some use of the variable has no fallback, so a recipient without
 * a value blocks the send. */
 const needsValue = (tokens, name) =>
  tokens.some(t => t.name === name && t.fallback === null); exports.needsValue = needsValue

/* Tokens that can never resolve: an invalid name, or a name the campaign
 * doesn't declare without a fallback. (An undeclared name with a fallback
 * always renders its fallback.) The built-in names are always declared. */
 const unresolvableTokens = (
  tokens,
  fields,
) => {
  const declared = new Set([...fields.map(f => f.Name), ..._broadcastTemplate.BUILT_IN_TEMPLATE_VARIABLES.map(b => b.Name)])
  return tokens.filter(t => !t.isValidName || (!declared.has(t.name) && t.fallback === null))
}; exports.unresolvableTokens = unresolvableTokens

/* A template that uses every declared variable once, without a fallback. The
 * launch gate run over it counts, per variable, the recipients with no value. */
 const coverageProbeTemplate = (fields) =>
  fields.map(f => `{{${f.Name}}}`).join(' '); exports.coverageProbeTemplate = coverageProbeTemplate







/* Per-variable coverage from the gate result of coverageProbeTemplate. */
 const variableCoverage = (
  fields,
  probe,
) => fields.map(field => {
  const missing = _nullishCoalesce(_optionalChain([probe, 'access', _ => _.MissingVariables, 'access', _2 => _2.find, 'call', _3 => _3(v => v.Name === field.Name), 'optionalAccess', _4 => _4.Count]), () => ( 0))
  return { ...field, have: probe.TotalRecipients - missing, total: probe.TotalRecipients }
}); exports.variableCoverage = variableCoverage

/* The token the caret sits in, or null. A caret right after a token's closing
 * braces is outside it. */
 const tokenAt = (tokens, position) =>
  _nullishCoalesce(tokens.find(t => position >= t.index && position < t.index + t.text.length), () => ( null)); exports.tokenAt = tokenAt

/* Characters a default can't contain: braces would end or nest the token. */
 const INVALID_DEFAULT = /[{}]/; exports.INVALID_DEFAULT = INVALID_DEFAULT

/* Rewrites the given token (or every use of its variable) to carry `value` as
 * its default: {{name | value}}. A blank value removes the default. */
 const setTokenDefault = (
  template,
  target,
  value,
  applyToAll,
) => {
  const trimmed = value.trim()
  const replacement = trimmed ? `{{${target.name} | ${trimmed}}}` : `{{${target.name}}}`
  const targets = exports.templateTokens.call(void 0, template)
    .filter(t => applyToAll ? t.name === target.name : t.index === target.index)
  let result = template
  // Right to left, so earlier indexes stay valid.
  for (const t of [...targets].reverse()) {
    result = result.slice(0, t.index) + replacement + result.slice(t.index + t.text.length)
  }
  return result
}; exports.setTokenDefault = setTokenDefault

/* Rev 35 E4: gives every use of the variable that has no fallback this one,
 * {{name | fallback}}; uses with their own fallback keep it. A blank fallback
 * changes nothing. */
 const addFallback = (template, name, fallback) => {
  const trimmed = fallback.trim()
  if (!trimmed) return template
  let result = template
  // Right to left, so earlier indexes stay valid.
  for (const t of exports.templateTokens.call(void 0, template).filter(t => t.name === name && t.fallback === null).reverse()) {
    result = result.slice(0, t.index) + `{{${name} | ${trimmed}}}` + result.slice(t.index + t.text.length)
  }
  return result
}; exports.addFallback = addFallback
